import classNames from "classnames"
import Badge from "../shared/Badge"
import { Icon, IconColor } from "../shared/Icon"
import { WearableCardProps, WearableCardStatus } from "."
import { TestId } from "@/constants/globals"

interface WearableCardMediumProps extends WearableCardProps {
   hasAction?: boolean
   isClickable?: boolean
}

const WearableCardMedium = ({
   status,
   chargeLevel,
   inmateName,
   hasAction,
   lowBattery,
   isClickable,
   isCollapsed,
   onClick,
}: WearableCardMediumProps) => {
   return (
      <Badge
         invisible={!hasAction}
         sx={{
            width: "100%",
         }}
      >
         <div
            className={classNames(
               "wearable-card wearable-card--medium",
               status && `wearable-card--${status}`,
               {
                  "wearable-card--clickable": isClickable,
                  "wearable-card--collapsed": isCollapsed,
               }
            )}
            style={{ ["--charge-level" as string]: `${chargeLevel}%` }}
            onClick={onClick}
         >
            {!status && (
               <Icon
                  className={classNames({
                     "wearable-card__battery-icon": lowBattery,
                  })}
                  size="16"
                  color={IconColor.WHITE}
                  name={lowBattery ? "batteryEmpty" : "smartwatch"}
               />
            )}
            <div className="wearable-card__label">{inmateName}</div>
            {!!chargeLevel && status === WearableCardStatus.CHARGING && (
               <div className="wearable-card__charge-level">
                  {`${chargeLevel}%`}
               </div>
            )}
            {status === WearableCardStatus.DISCONNECTED && (
               <Icon
                  size="16"
                  color={IconColor.WHITE}
                  name="disconnected"
               />
            )}
            {status === WearableCardStatus.UNASSIGNED && (
               <Icon
                  size="16"
                  color={IconColor.WHITE}
                  name="unlinked"
                  data-testid={TestId.WEARABLE_CARD_UNASSIGNED_ICON}
               />
            )}
         </div>
      </Badge>
   )
}

export default WearableCardMedium
